import request from "@/utils/request";

let BusinessApi = {
  // 商学院
  /*文本列表*/
  indexbusiness(data, errorback) {
    return request._post("/shop/agreement.business/index", data, errorback);
  },
  /*添加文本*/
  addbusiness(data, errorback) {
    return request._post("/shop/agreement.business/add", data, errorback);
  },
  /*编辑文本*/
  editbusiness(data, errorback) {
    return request._post("/shop/agreement.business/edituser", data, errorback);
  },
  /*删除文本*/
  deletebusiness(data, errorback) {
    return request._post("/shop/agreement.business/delete", data, errorback);
  },

  /*文本列表*/
  indexnotice(data, errorback) {
    return request._post(
      "/shop/agreement.business_activity/index",
      data,
      errorback
    );
  },
  /*添加文本*/
  addnotice(data, errorback) {
    return request._post(
      "/shop/agreement.business_activity/add",
      data,
      errorback
    );
  },
  /*编辑文本*/
  editnotice(data, errorback) {
    return request._post(
      "/shop/agreement.business_activity/edituser",
      data,
      errorback
    );
  },
  /*删除文本*/
  deletenotice(data, errorback) {
    return request._post(
      "/shop/agreement.business_activity/delete",
      data,
      errorback
    );
  }
};

export default BusinessApi;



// WEBPACK FOOTER //
// ./src/api/business.js